import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import SEOHead from "@/components/base/SEOHead";
import Hero from "./components/Hero";
import CategoryNav from "./components/CategoryNav";
import FeaturedArticles from "./components/FeaturedArticles";
import LatestArticles from "./components/LatestArticles";
import Newsletter from "./components/Newsletter";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "91精选",
  url: "https://91jingxuan.com",
  description: "91精选是专注优质内容发现与聚合的精品平台，汇集海量精选资源，帮助用户快速找到最值得收藏的好内容。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://91jingxuan.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "91精选",
  url: "https://91jingxuan.com",
  description: "精品内容聚合平台，专注优质内容发现与精选推荐",
  sameAs: [
    "https://twitter.com/91jingxuan",
    "https://weibo.com/91jingxuan",
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="91精选 - 精品内容聚合平台，发现最值得收藏的优质资源"
        description="91精选是专注优质内容发现与聚合的精品平台，汇集海量精选资源，帮助用户快速找到最值得收藏的好内容。无论是实用工具、优质素材还是精品推荐，91精选都为您严格筛选，节省您的时间与精力。"
        keywords="91精选,91精选资源,91精选精品内容,91精选推荐,精选内容聚合,优质资源精选,精品内容推荐,精选收藏平台"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20minimalist%20content%20curation%20platform%20branding%2C%20warm%20elegant%20design%2C%20clean%20typography%2C%20abstract%20geometric%20shapes%2C%20coral%20and%20cream%20gradient%2C%20premium%20content%20discovery%2C%20sophisticated%20aesthetic&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={{ ...homeSchema, ...orgSchema }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <CategoryNav />
          <FeaturedArticles />
          <LatestArticles />
          <Newsletter />
        </main>
        <Footer />
      </div>
    </>
  );
}